import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b1540db0&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b1540db0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1540db0",
  null
  
)

export default component.exports